import { useEffect } from "react";
import { sharedAttributionVisitorId } from "../../../shared/attribution/useAttributionVisitor";

const axios = require("axios").default;

const useLinkAttributionVisitor = ({ confirmId, userContext, attributionVisitorUuid }) => {
  const accessToken = userContext && userContext.access_token;
  const visitorUuid = attributionVisitorUuid || sharedAttributionVisitorId();

  useEffect(() => {
    if (!accessToken || !visitorUuid) return;

    axios.post("/attribution/login_links", {
      confirm_id: confirmId,
      ucat: accessToken,
      attribution_visitor_uuid: visitorUuid
    }).catch(() => {});
  }, [confirmId, accessToken, visitorUuid]);
};

export default useLinkAttributionVisitor;
